<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useInventObjectLink } from './../model/model.ts'

const props = defineProps({
  objectId: {
    type: Number,
    default: 0,
  },
  objectType: {
    type: Number,
    default: 0,
  },
})

const model = useInventObjectLink()

/**
 * Функция установки значения связуемого объекта
 */
const clickHandler = () => {
  model.data = {
    ...model.data,
    object_from: props.objectId,
    object_type: props.objectType,
  }

  model.open = true
}
</script>

<template>
  <VTooltip location="top" :open-delay="1000" :text="$t('itf.map_link_object')">
    <template #activator="{ props: tooltipProps }">
      <VBtn v-bind="tooltipProps" variant="outlined" @click="clickHandler">
        <VIcons type="add_link" />
      </VBtn>
    </template>
  </VTooltip>
</template>
